import React, { useEffect, useState } from 'react'
import DateRange from '../../Component/DateRange/DateRange';
import { Col, Pagination, Row } from 'react-bootstrap';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ScreenPagination from '../../Component/ScreenPagination/ScreenPagination';
import { URLS } from '../../Services/Constant';
import moment from 'moment';
import { Toast } from '../../Component/Toast';
import { get } from '../../Services/ApiHandler';
import useStore from '../../LocalStore/useStore';
import CustomScroll from '../../Component/CustomScroll';

const WinningHistory = () => {

    const { kv, set } = useStore();
    const winningObj = kv.winning_obj || [];

    const [data, setData] = useState(winningObj);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [todayAmount, setTodayAmount] = useState(0);
    const [displayDate, setDisplayDate] = useState("");
    const [selectedDate, setSelectedDate] = useState(new Date());


    const getList = async (date = selectedDate) => {
        try {
            let url = `?page=${pageNumber}`;

            if (date) {
                url += `&date=${moment(date).format("YYYY-MM-DD")}`;
            }

            const res = await get(URLS.WINNING + url);

            if (res?.status === "success" && Array.isArray(res?.data)) {
                setData(res.data);
                set("winning_obj", res.data);
                setTotalPages(res?.pagination?.total_pages || 1);
                setTodayAmount(res?.overall_winning_amount);
            } else {
                setData([]);
                setTotalPages(1);
            }
        } catch (err) {
            Toast("Failed to load history");
        }
    };

    // pagination effect
    useEffect(() => {
        getList();
    }, [pageNumber]);




    return (
        <div style={{ paddingBottom: 40 }} className="dashRightView-foots ">
            <CustomScroll >
                <div style={{ marginBottom: 50 }} className=" containers_list p-3">
                    <DateRange
                        fromDate={selectedDate}
                        onChange={(date) => {
                            setSelectedDate(date);
                            getList(date); // fetch on date change
                        }}
                    />
                    <div style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 310px)', padding: '5px' }}>
                        {data.length === 0 && (
                            <div className="no-data-found d-flex ac-jc flex-column">
                                <p className='f3 mt-2'>No Data</p>
                            </div>
                        )}
                        {data.map((item) => {
                            return (
                                <div className="calender-input-daily mt-4 p-3">
                                    <div className="d-flex ac-jb">
                                        <p className="f4 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-20 fs-xxl-20 "> Date  </p>
                                        <p className="f2 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-20 fs-xxl-20 gray">{item?.date} </p>
                                    </div>
                                    <div className="d-flex ac-jb mt-2">
                                        <p className="f4 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-20 fs-xxl-20 "> Lot Name  </p>
                                        <p className="f2 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-20 fs-xxl-20 gray">{item?.lot_name == "Kerala" ? "Kerala" : "Dear"}</p>
                                    </div>
                                    <div className="d-flex ac-jb mt-2">
                                        <p className="f4 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-20 fs-xxl-20 "> Time </p>
                                        <p className="f2 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-20 fs-xxl-20 gray">{item?.lot_time}</p>
                                    </div>
                                    <div className="d-flex ac-jb mt-2">
                                        <p className="f4 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-20 fs-xxl-20 "> Prize Amount  </p>
                                        <p style={{ color: '#8F0D3d' }} className="f3 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-20 fs-xxl-20 primary">₹ {item?.price_amount} </p>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </CustomScroll>
            <ScreenPagination marignBtn={2} pagiantionFalse={true} show={true} amount={true} todayAmount={todayAmount} setPagenumber={setPageNumber} pagenumber={pageNumber} totalPages={totalPages} selectedDate={selectedDate ? (moment(selectedDate).isSame(moment(), 'day') ? 'Today' : moment(selectedDate).format("DD-MM-YYYY")) : 'Today'} />

        </div>
    )
}

export default WinningHistory